import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import cx from "classnames";
import styles from "./modal.module.scss";

type ModalProps = {
  onClose: () => void;
  className?: string;
};

const Modal: React.FC<ModalProps> = ({ onClose, children, className }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setContainer(document.getElementById("modal-container"));
  }, []);

  if (container === null) {
    return null;
  }

  const overlayClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {createPortal(
        <>
          <div
            style={{ zIndex: 100 }}
            onMouseDown={overlayClick}
            className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-25 flex justify-center items-center overflow-scroll py-20"
          >
            <div
              style={{ zIndex: 101 }}
              className={cx(
                styles.modal,
                "bg-white rounded-md w-11/12 sm:w-10/12 md:w-9/12 shadow-xl",
                className
              )}
            >
              {children}
            </div>
          </div>
        </>,
        container
      )}
    </>
  );
};

export default Modal;
